export enum SplitComponentEnum {
    LegalizationDetails = 1
}